import { api } from './api';
import { buildFormData } from './utils';

/**
 * Status
 * --------------
 */
export function getStatus() {
  return api.get(`/noauth-status`);
}

/**
 * BRANDS
 * --------------
 */
export function getBrands(params) {
  return api.get(`/brands`, {
    params
  });
}

/**
 * CUSTOMERS
 * --------------
 */
export function getCustomers(params) {
  return api.get(`/customers`, {
    params
  });
}
export function getCustomer(id) {
  return api.get(`/customers/${id}`);
}
export function getCustomerDetails(id) {
  return api.get(`/customers/${id}/details`);
}
export function getCustomerMessages(id, params) {
  return api.get(`/customers/${id}/messages`, {
    params
  });
}
export function sendCustomerMessage(id, data) {
  return api.post(`/customers/${id}/messages`, data);
}
export function getCustomerActions(id) {
  return api.get(`/customers/${id}/actions`);
}
export function unsubscribeEmail(company, email, email_optstatus_id, status) {
  if (email_optstatus_id) {
    return api.patch(`/unsubscribes/${email_optstatus_id}`, {
      status
    });
  }
  return api.post(`/unsubscribes`, {
    company,
    email,
    status
  });
}
export function updateSMSStatus(company, phone, sms_optstatus_id, status) {
  if (sms_optstatus_id) {
    return api.patch(`/sms-optstatuses/${sms_optstatus_id}`, {
      status
    });
  }
  return api.post(`/sms-optstatuses`, {
    company,
    phone,
    status
  });
}
export function getOptStatusSMS(params) {
  return api.get(`/sms-optstatuses`, {
    params
  });
}
export function unsubscribeEmailDelete(unsubscribe_id) {
  return api.delete(`/unsubscribes/${unsubscribe_id}`);
}
export function getCustomerRefGroups(params) {
  return api.get(`/customer-ref-groups`, {
    params
  });
}
export function createCustomerRefGroups(data) {
  return api.post(`/customer-ref-groups`, data);
}
export function editCustomerRefGroup(id, data) {
  return api.patch(`customer-ref-groups/${id}`, data);
}
export function editCustomer(id, data) {
  return api.patch(`/customers/${id}`, data);
}

/**
 * NAICS
 * --------------
 */
export function getNAICS(params) {
  return api.get(`/naics`, {
    params
  });
}

/**
 * USERS
 * --------------
 */
export function getUsers(params) {
  return api.get(`/users`, {
    params
  });
}
export function getUser(id, params) {
  return api.get(`/users/${id}`, {
    params
  });
}
export function updateUser(id, data) {
  return api.patch(`/users/${id}`, data);
}
export function inviteUser(data) {
  return api.post(`/users/invite`, data);
}
export function newUser(first_name, last_name, email, role, is_active, password) {
  return api.post('/users', {
    first_name,
    last_name,
    email,
    role,
    is_active,
    password
  });
}
export function editUser(id, body) {
  return api.patch(`/users/${id}`, body);
}

/**
 * ANALYTICS
 * --------------
 */

export function getAnalytics(params) {
  return api.get(`/analytics/views`, {
    params: {
      ordering: 'display_name',
      ...params
    }
  });
}

/**
 * COMPANIES
 * --------------
 */
export function getCompanies(params) {
  return api.get(`/companies`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}
export function getCompany(id, params) {
  return api.get(`/companies/${id}`, {
    params
  });
}
export function getCompanyFields(id) {
  return api.get(`/companies/${id}/fields`);
}
export function getCompanyPhoneCount(id) {
  return api.get(`/companies/${id}/phone_count`);
}
export function refreshAllCompanyFields(id) {
  return api.post(`/companies/${id}/refresh_fields`);
}
export function getAllCompanyFields(id) {
  return api.get(`/companies/${id}/all_fields`);
}
export function postCompany(data) {
  return api.post('/companies', data);
}
export function patchCompany(id, data) {
  return api.patch(`/companies/${id}`, data);
}
export function getCompanyFiles(id) {
  return api.get(`/company-files/${id}/files`);
}
export function createCompanyFilesFolder(id, folder) {
  return api.post(`/company-files/${id}/folder`, {
    folder
  });
}
export function deleteCompanyFile(id, key) {
  return api.delete(`/company-files/${id}/key?key=${encodeURIComponent(key)}`);
}
export function renameCompanyFile(id, old_key, new_key) {
  return api.post(`/company-files/${id}/rename`, {
    old_key,
    new_key
  });
}
export function checkCompanyFields(id, data) {
  return api.post(`/companies/${id}/field_check`, data);
}
export function getCompanyStatuses(params) {
  return api.get(`/companies/statuses`, {
    params
  });
}
export function getCompanyCancelReasons(params) {
  return api.get(`/companies/cancel-reasons`, {
    params
  });
}
export function getAccounts(params) {
  return api.get(`/accounts`, {
    params
  });
}
export function duplicateCompany(data, id) {
  return api.post(`/companies/${id}/duplicate`, data);
}

/**
 * JOURNEYS
 * --------------
 */
export function getJourneys(params) {
  return api.get(`/journeys`, {
    params
  });
}
export function getJourneyTemplates(params) {
  return api.get(`/journeys/templates`, {
    params
  });
}
export function getJourney(journeyId) {
  return api.get(`/journeys/${journeyId}`);
}
export function getJourneyRevisions(journeyId, params) {
  return api.get(`/journeys/${journeyId}/revisions`, {
    params
  });
}
export function getJourneyNodes(revisionId) {
  return api.get(`/journeys/revisions/${revisionId}`);
}
export function getJourneysTags(companyId) {
  return api.get(`/journeys/tags/${companyId}`);
}
export function getJourneyReasons(companyId) {
  return api.get(`/journeys/reasons/${companyId}`);
}
export function getJourneyEndStats(journeyId) {
  return api.get(`/journeys/${journeyId}/end-stats`);
}
export function createJourney(name, company) {
  return api.post(`/journeys`, {
    name,
    company
  });
}
export function createJourneyFromTemplate(templateId, companyId) {
  return api.post(`/journeys/from_template/${templateId}/to_company/${companyId}`);
}
export function deleteJourney(journeyId) {
  return api.delete(`/journeys/${journeyId}`);
}
export function patchJourney(journeyId, body) {
  return api.patch(`/journeys/${journeyId}`, body);
}
export function patchRevision(revisionId, body) {
  return api.patch(`/journeys/revisions/${revisionId}`, body);
}
export function deleteRevision(revisionId) {
  return api.delete(`/journeys/revisions/${revisionId}`);
}
export function getRevisionAnalytics(revisionId, params) {
  // Automatically timeout after 5 minutes
  return api.get(`/journeys/revisions/${revisionId}/analytics`, {
    params,
    timeout: 300000
  });
}
export function duplicateJourney(journeyId) {
  return api.post(`/journeys/${journeyId}/duplicate`);
}
export function revertJourney(journeyId) {
  return api.post(`/journeys/${journeyId}/revert`);
}

/**
 * NODES
 * --------------
 */
export function createNode(node_type, name, x, y, revision, parameters) {
  return api.post(`/journeys/nodes`, {
    node_type,
    name,
    x,
    y,
    revision,
    parameters
  });
}
export function removeNode(nodeId) {
  return api.delete(`/journeys/nodes/${nodeId}`);
}
export function updateNode(nodeId, body) {
  return api.patch(`/journeys/nodes/${nodeId}`, body);
}
export function testSQL(sql) {
  return api.post(`/journeys/nodes/test-sql`, {
    sql
  });
}
export function testBulkSQL(sql, values) {
  return api.post(`/journeys/nodes/test-bulk-sql`, {
    sql,
    values
  });
}
export function getNodeCustomers(nodeId, params) {
  return api.get(`/journeys/nodes/${nodeId}/customers`, {
    params
  });
}
export function createNodeCustomersSegment(nodeId, params) {
  return api.post(`/journeys/nodes/${nodeId}/to-segment`, {
    params
  });
}

/**
 * JOURNEY LINKS
 * --------------
 */
export function createLink(from_node, to_node, on_event) {
  return api.post(`/journeys/links`, {
    from_node,
    to_node,
    on_event
  });
}
export function updateLink(id, body) {
  return api.patch(`/journeys/links/${id}`, body);
}
export function removeLink(linkId) {
  return api.delete(`/journeys/links/${linkId}`);
}

/**
 * SEGMENTS
 * --------------
 */

export function createCustomerSegment(customerSegment) {
  return api.post('/customer-segments', customerSegment);
}
export function deleteCustomerSegment(id) {
  return api.delete('/customer-segments/' + id);
}
export function segmentConvertToQuery(params) {
  return api.post(`/segments/convert-query`, params);
}
export function getSegments(params) {
  return api.get(`/segments`, {
    params: {
      archived: false,
      ordering: 'name',
      ...params
    }
  });
}
export function getSegment(id, params) {
  return api.get(`/segments/${id}`, {
    params
  });
}
export function getSegmentCustomers(id, params) {
  return api.get(`/segments/${id}/customers`, {
    params
  });
}
export function getSegmentCount(id, params) {
  // We're appending an aprt controller to the promise.  We may want to always do this but I'm not sure.
  const controller = new AbortController();
  const promise = api.get(`/segments/${id}/counts`, {
    params,
    signal: controller.signal
  });
  promise.controller = controller;
  return promise;
}
export function newSegment(segment) {
  return api.post('/segments', segment);
}
export function editSegment(id, segment) {
  return api.patch(`/segments/${id}`, segment);
}
export function copySegment(segment) {
  return api.post('/segments', segment);
}
export function deleteSegment(id) {
  return api.delete(`/segments/${id}`);
}
export function getSegmentExport(id) {
  return api.get(`/segments/${id}/customers.csv`, {
    responseType: 'blob'
  });
}
export function createSegmentFromTemplate(segmentId, companyId) {
  return api.post(`/segments/from-template/${segmentId}/to-company/${companyId}`);
}
export function testSegment(segment) {
  return api.post(`/segments/test-count`, segment);
}
export function getSegmentsTags(companyId) {
  return api.get(`/segments/tags/${companyId}`);
}

/**
 * SEGMENT TEMPLATES
 * --------------
 */
export function getSegmentTemplates(params) {
  return api.get(`/segment-templates`, {
    params
  });
}

/**
 * LOCATIONS
 * --------------
 */
export function getLocations(params) {
  return api.get(`/locations`, {
    params
  });
}
export function getLocation(id, params) {
  return api.get(`/locations/${id}`, {
    params
  });
}
export function editLocation(id, data) {
  return api.patch(`/locations/${id}`, data);
}

/**
 * MARKETS
 * --------------
 */
export function getMarkets(params) {
  return api.get(`/markets`, {
    params
  });
}
export function getMarket(id, params) {
  return api.get(`/markets/${id}`, {
    params
  });
}

/**
 * COUPONS
 * --------------
 */
export function getCoupons(params) {
  return api.get(`/coupons`, {
    params
  });
}
export function getCoupon(id, params) {
  return api.get(`/coupons/${id}`, {
    params
  });
}
export function newCoupon(body) {
  return api.post('/coupons', buildFormData(body), {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export function getCouponBatches(couponId) {
  return api.get(`/coupons/${couponId}/batches`);
}
export function downloadCouponBatch(couponId, batchNumber) {
  return api.get(`/coupons/${couponId}/download-batch/${batchNumber}`);
}
export function createCoupon(data) {
  return api.post('/coupons', data);
}
export function createCouponBatch(id, data) {
  return api.post(`/coupons/${id}/generate-batch`, data);
}
export function editCoupon(id, body) {
  return api.patch(`/coupons/${id}`, buildFormData(body), {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export function copyCoupon(body) {
  return api.post('/coupons', buildFormData(body), {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
export function deleteCoupon(id) {
  return api.delete(`/coupons/${id}`);
}

/**
 * ROLES
 * --------------
 */
export function getRoles(params) {
  return api.get(`/roles`, {
    params
  });
}
export function getRole(id) {
  return api.get(`/roles/${id}`);
}
export function updateRole(id, role) {
  return api.patch(`/roles/${id}`, role);
}
export function createRole(role) {
  return api.post(`/roles`, role);
}
export function deleteRole(id) {
  return api.delete(`/roles/${id}`);
}

/**
 * USER COMPANIES
 * --------------
 */
export function getUserCompanies(id, params) {
  return api.get(`/users/${id}/companies`, {
    id,
    params
  });
}
export function deleteUserCompany(id) {
  return api.delete(`/users/companies/${id}`);
}
export function updateUserCompany(id, data) {
  return api.patch(`/users/companies/${id}`, data);
}
export function createUserCompany(data) {
  return api.post(`/users/companies`, data);
}

/**
 * TEMPLATES
 * --------------
 */

//CLEAN THIS AVOID HARD CODE PARAMS
export function getTemplates(params) {
  return api.get(`/templates`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}
//CLEAN THIS AVOID HARD CODE PARAMS
export function getEmailTemplates(params) {
  return api.get(`templates/emails`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}
//CLEAN THIS AVOID HARD CODE PARAMS
export function getPrintTemplates(params) {
  return api.get(`templates/prints`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}
export function getTemplatesTags(companyId) {
  return api.get(`/templates/tags/${companyId}`);
}
export function getSmsTemplates(params) {
  return api.get(`templates/sms`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}
/**
 * TEMPLATES - EMAILS
 * --------------
 */

export function getEmail(id) {
  return api.get(`templates/emails/${id}`);
}
export function postEmail(body) {
  return api.post(`/templates/emails`, body);
}
export function getEmailRevision(id) {
  return api.get(`templates/email-revisions/${id}`);
}
export function createEmailRevision(body) {
  return api.post(`/templates/email-revisions`, body);
}
export function updateEmailRevision(id, body) {
  return api.patch(`/templates/email-revisions/${id}`, body);
}
export function patchEmail(id, body) {
  return api.patch(`/templates/emails/${id}`, body);
}
export function deleteEmail(id) {
  return api.delete(`/templates/emails/${id}`);
}
export function duplicateEmail(id) {
  return api.post(`/templates/emails/${id}/duplicate`);
}
export function createEmailFromTemplate(templateId, companyId) {
  return api.post(`/templates/emails/from-template/${templateId}/to-company/${companyId}`);
}

/**
 * TEMPLATES - EMAIL TEMPLATES
 * --------------
 */
export function getEmailTemplateTemplates(params) {
  return api.get(`/email-templates`, {
    params: {
      ordering: 'email__name',
      ...params
    }
  });
}
export function getPremadeBlocksTemplate(params) {
  return api.get(`/email-blocks/get`, {
    params
  });
}
export function createPremadeBlocksTemplate(block) {
  return api.post(`/email-blocks`, block);
}
export function updatePremadeBlocksTemplate(id, savedBlock) {
  return api.patch(`/email-blocks/${id}`, savedBlock);
}
export function deletePremadeBlocksTemplate(id, savedBlock) {
  return api.delete(`/email-blocks/${id}`, savedBlock);
}

/**
 * TEMPLATES - MAILS
 * --------------
 */
export function getMail(id) {
  return api.get(`templates/prints/${id}`);
}
export function postPrints(body) {
  return api.post(`/templates/prints`, body);
}
export function patchPrints(id, body, params) {
  return api.patch(`/templates/prints/${id}`, body, params);
}
export function getPrintRevision(id) {
  return api.get(`templates/print-revisions/${id}`);
}
export function createPrintRevision(body) {
  return api.post(`/templates/print-revisions`, body);
}
export function createPrintRevisionFromDraft(id) {
  return api.post(`/templates/print-revisions/${id}/duplicate`);
}
export function updatePrintRevision(id, body) {
  return api.patch(`/templates/print-revisions/${id}`, body);
}
export function deleteMail(id) {
  return api.delete(`/templates/prints/${id}`);
}
export function duplicateMail(id) {
  return api.post(`/templates/prints/${id}/duplicate`);
}
export function createPrintFromTemplate(templateId, companyId) {
  return api.post(`/templates/prints/from-template/${templateId}/to-company/${companyId}`);
}

/**
 * TEMPLATES - PRINT TEMPLATES
 * --------------
 */
export function getPrintTemplateTemplates(params) {
  return api.get(`/print-templates`, {
    params: {
      ordering: 'name',
      ...params
    }
  });
}

/**
 * TEMPLATES - SMS
 * --------------
 */

export function getSms(id) {
  return api.get(`templates/sms/${id}`);
}
export function postSms(body) {
  return api.post(`/templates/sms`, body);
}
export function getSmsRevision(id) {
  return api.get(`templates/sms-revisions/${id}`);
}
export function createSmsRevision(body) {
  return api.post(`/templates/sms-revisions`, body);
}
export function updateSmsRevision(id, body) {
  return api.patch(`/templates/sms-revisions/${id}`, body);
}
export function patchSms(id, body) {
  return api.patch(`/templates/sms/${id}`, body);
}
export function deleteSms(id) {
  return api.delete(`/templates/sms/${id}`);
}
export function duplicateSms(id) {
  return api.post(`/templates/sms/${id}/duplicate`);
}
export function getSmsTemplateTemplates(params) {
  return api.get(`/sms-templates`, {
    params: {
      ordering: 'sms__name',
      ...params
    }
  });
}
export function sendTestSmsMessage(data) {
  return api.post(`/templates/sms-revisions/test-sms`, data);
}
export function generatePreview(data) {
  return api.post(`/templates/sms-revisions/generate-preview`, data);
}
export function createSmsFromTemplate(templateId, companyId) {
  return api.post(`/templates/sms/from-template/${templateId}/to-company/${companyId}`);
}
/**
 * CHARGEBEE
 */
export function getChargeBeeCheckoutURL(companyId) {
  return api.get(`/chargebee/hosted/${companyId}/url`);
}
export function getChargeBeeSubscriptionURL(companyId) {
  return api.get(`/chargebee/hosted/${companyId}/portal`);
}
export function createChargeBeeSubscription(data) {
  return api.post(`/chargebee/subscription`, data);
}
export function getChargeBeeSubscription(company) {
  return api.get('/chargebee/subscription', {
    params: {
      company
    }
  });
}
export function getChargeBeeAddons(company) {
  return api.get(`/chargebee/company/${company}/addons`);
}
export function getChargeBeePlan(company) {
  return api.get(`/chargebee/company/${company}/plan`);
}

/*
 * BROADCAST
 */
export function getBroadcasts(params) {
  return api.get(`/broadcasts`, {
    params
  });
}
export function createBroadcast(body) {
  return api.post(`/broadcasts`, body);
}
export function updateBroadcast(id, body) {
  return api.patch(`/broadcasts/${id}`, body);
}
export function deleteBroadcast(id) {
  return api.delete(`/broadcasts/${id}`);
}

/*
 * SMS BROADCAST
 */
export function getSmsBroadcasts(params) {
  return api.get(`/communication/sms/broadcasts`, {
    params
  });
}
export function createSmsBroadcast(body) {
  return api.post(`/communication/sms/broadcasts`, body);
}
export function updateSmsBroadcast(id, body) {
  return api.patch(`/communication/sms/broadcasts/${id}`, body);
}
export function deleteSmsBroadcast(id) {
  return api.delete(`/communication/sms/broadcasts/${id}`);
}

/**
 * SMS
 */
export function getPhoneNumbers(params) {
  return api.get(`/communication/phone-number`, {
    params
  });
}
export function getAvailablePhoneNumbers(params) {
  return api.get(`/communication/phone-number/available`, {
    params
  });
}
export function getPhoneRegistration(company) {
  return api.get(`/communication/phone-number/registration`, {
    params: {
      company
    }
  });
}
export function updateBusinessInformation(data) {
  return api.post(`/communication/phone-number/business_information`, data);
}
export function getPossibleUseCases(company) {
  return api.get(`/communication/phone-number/use_cases`, {
    params: {
      company
    }
  });
}
export function createMessageCampaign(data) {
  return api.post(`/communication/phone-number/campaign`, data);
}
export function updateBusinessAddress(data) {
  return api.post(`/communication/phone-number/business_address`, data);
}
export function updateAuthorizedRepresentative(data) {
  return api.post(`/communication/phone-number/authorized_representative`, data);
}
export function updateA2PBusinessInformation(data) {
  return api.post(`/communication/phone-number/a2p_business_information`, data);
}
export function verifyCustomerProfile(company) {
  return api.get(`/communication/phone-number/verify`, {
    params: {
      company
    }
  });
}
export function submitCustomerProfile(company) {
  return api.post(`/communication/phone-number/submit`, {
    company
  });
}
export function submitBrand(company) {
  return api.post(`/communication/phone-number/submit_brand`, {
    company
  });
}
export function verifyA2P(company) {
  return api.get(`/communication/phone-number/verify_a2p`, {
    params: {
      company
    }
  });
}
export function submitA2P(company) {
  return api.post(`/communication/phone-number/submit_a2p`, {
    company
  });
}
export function updatePhoneNumber(id, body) {
  return api.patch(`/communication/phone-number/${id}`, body);
}
export function deletePhoneNumber(id) {
  return api.delete(`/communication/phone-number/${id}`);
}
export function purchasePhoneNumber(data) {
  return api.post(`/communication/phone-number/purchase`, data);
}
export function getMessaging(params) {
  return api.get(`/communication/sms`, {
    params
  });
}

/**
 * DOMAINS
 */
export function getDomains(params) {
  return api.get(`/email/domains`, {
    params
  });
}
export function createDomains(body) {
  return api.post(`/email/domains`, body);
}
export function verifyDomain(id) {
  return api.post(`/email/domains/${id}/verify`);
}
export function deleteDomain(id) {
  return api.delete(`/email/domains/${id}`);
}

/**
 * EMAIL ADDRESSES
 */
export function getAddresses(params) {
  return api.get(`/email/addresses`, {
    params
  });
}
export function getAddress(id) {
  return api.get(`/email/addresses/${id}`);
}
export function createAddress(body) {
  return api.post(`/email/addresses`, body);
}
export function verifyAddress(id, hash) {
  return api.post(`/email/addresses/${id}/verify/${hash}`);
}
export function resendVerificationEmail(id) {
  return api.post(`/email/addresses/${id}/resend`);
}
export function rejectAddress(id) {
  return api.post(`/email/addresses/${id}/reject`);
}
export function deleteAddress(id) {
  return api.delete(`/email/addresses/${id}`);
}

// EMAIL METRICS

export function getEmailMetrics(node_id, days) {
  return api.get(`/email/journeys/metrics?node_id=${node_id}${days ? `&days=${days}` : ''}`);
}

/**
 * CSV Imports
 */

export function getImports(params) {
  return api.get(`/integration/csvimport`, {
    params
  });
}
export function getCSVImportSources(params) {
  return api.get(`/integration/csvimport/sources`, {
    params
  });
}
export function importCSV(data) {
  return api.post(`/integration/csvimport`, data);
}
export function deleteImport(id) {
  return api.delete(`/integration/csvimport/${id}`);
}

/**
 * Surveys
 */
export function getSurveys(params) {
  return api.get(`/surveys`, {
    params
  });
}
export function getSurvey(id) {
  return api.get(`/surveys/${id}`);
}
export function createSurvey(body) {
  return api.post(`/surveys`, body);
}
export function updateSurvey(id, body) {
  return api.patch(`/surveys/${id}`, body);
}
export function deleteSurvey(id) {
  return api.delete(`/surveys/${id}`);
}
export function duplicateSurvey(id) {
  return api.post(`/surveys/${id}/duplicate`);
}
export function getSurveyRevisions(params) {
  return api.get(`/surveys/revisions`, {
    params
  });
}
export function createSurveyRevision(body) {
  return api.post(`/surveys/revisions`, body);
}
export function getSurveyRevision(id) {
  return api.get(`/surveys/revisions/${id}`);
}
export function updateSurveyRevision(id, body) {
  return api.patch(`/surveys/revisions/${id}`, body);
}
export function deleteSurveyRevision(id) {
  return api.delete(`/surveys/revisions/${id}`);
}
export function getSurveyQuestions(params) {
  return api.get(`/surveys/questions`, {
    params
  });
}
export function createSurveyQuestion(body) {
  return api.post(`/surveys/questions`, body);
}
export function getSurveyQuestion(id) {
  return api.get(`/surveys/questions/${id}`);
}
export function updateSurveyQuestion(id, body) {
  return api.patch(`/surveys/questions/${id}`, body);
}
export function deleteSurveyQuestion(id) {
  return api.delete(`/surveys/questions/${id}`);
}

/**
 * Folders
 */

export function getCompanyFolders(params) {
  return api.get(`/folder`, {
    params
  });
}
export function createNewFolder(body) {
  return api.post(`/folder`, body);
}
export function updateFolder(id, body) {
  return api.patch(`/folder/${id}`, body);
}
export function deleteFolder(id) {
  return api.delete(`/folder/${id}`);
}

/**
 * Reviews
 */

export function getReviews(params) {
  return api.get(`/reviews`, {
    params
  });
}
export function editReviews(id, data) {
  return api.patch(`/reviews/${id}`, data);
}
export function sendReviewReply(id, data) {
  return api.post(`/reviews/${id}/reply`, data);
}
export function getReviewsLocations(params) {
  return api.get(`/reviews/locations`, {
    params
  });
}